"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeLegendSelector = void 0;
var create_selector_1 = require("../../../../state/create_selector");
var get_deselected_data_series_1 = require("../../../../state/selectors/get_deselected_data_series");
var get_color_scale_1 = require("./get_color_scale");
var heatmap_spec_1 = require("./heatmap_spec");
var EMPTY_LEGEND = [];
exports.computeLegendSelector = (0, create_selector_1.createCustomCachedSelector)([heatmap_spec_1.getSpecOrNull, get_color_scale_1.getColorScale, get_deselected_data_series_1.getDeselectedSeriesSelector], function (spec, _a, deselectedDataSeries) {
    var bands = _a.bands;
    if (spec === null) {
        return EMPTY_LEGEND;
    }
    return bands.map(function (_a) {
        var label = _a.label, color = _a.color;
        return {
            seriesIdentifiers: [{ key: label, specId: label }],
            color: color,
            label: label,
            isSeriesHidden: deselectedDataSeries.some(function (dataSeries) { return dataSeries.key === label; }),
            isToggleable: true,
            path: [{ index: 0, value: label }],
            keys: [],
        };
    });
});
//# sourceMappingURL=compute_legend.js.map